module.exports = __webpack_public_path__ + "img/lighitning.a1bc7f8f.gif";